<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="close" v-on:click="close"></div>
      <div class="modalContent" :style="{'background-image': `url(${m.media.imageLg})`}"
         v-on:click="close"></div>
      <div class="mediaLabel" v-if="m.mediaLabel" v-on:click="close">{{m.mediaLabel}}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      m: null,
    };
  },
  methods: {
    open(d, next) {
      this.m = d;
      this.next = next;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .close{
      width: 36px; height: 36px;
      border-radius: 50%;
      position: absolute;
      right: 10px; top: 10px;
      background-image: url(../assets/close-white.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      z-index: 3;
      &:hover{
        background-color: rgba(255,255,255,.2);
      }
    }
    .modalContent{
      position: absolute;
      top: 40px; left: 20px; right: 20px; bottom: 100px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 2;
    }
    .mediaLabel{
      position: absolute;
      left: 20px; right: 20px; bottom: 20px;
      height: 70px;
      z-index: 2;
      color: #fff;
      text-align: center;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
